import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import './index.css';
import App from './App';

// 设置dayjs中文
dayjs.locale('zh-cn');

// 创建React Query客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // 对于认证错误，不要重试
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          return false;
        }
        // 最多重试2次
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5分钟
      onError: (error) => {
        // 只对非认证错误显示通用错误信息
        if (error?.response?.status !== 401 && error?.response?.status !== 403) {
          console.error('Query error:', error);
        }
      },
    },
    mutations: {
      onError: (error) => {
        // 对于mutation错误，显示错误信息（除了认证错误）
        if (error?.response?.status !== 401 && error?.response?.status !== 403) {
          console.error('Mutation error:', error);
        }
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhCN}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
